<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml" xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="m-h-10 p-v-10 p-h-10" style="background-color: #F9F9F9">
    <div class="w-full flex m-b-10">
      <slot name="leftBtn"></slot>
      <class-choose-widget :gutter="10" :srcType="6" @dataChange="onClassGroupChange" leftPlaceholder="图片分类"
                           rightPlaceholder="图片分组" style="width: 240px;">
      </class-choose-widget>

      <Input class="m-l-15" placeholder="图片名称" style="width: 160px" v-model="searchName"/>
      <Button @click="onSearchClick" class="m-l-15">搜索</Button>

      <div class="flex-1 flex-shrink-1 j-end"></div>

      <up-load-image :multiple="multiple" :picurl="picurl" @uploadSuccess="uploadcoversuccess($event)"
                     accept="image/*"
                     style="width: auto;">
        <template v-slot:tip>
          <Button class="" type="primary">本地上传</Button>
        </template>
      </up-load-image>

    </div>
    <!--列表数据-->
    <div class=" scrollbar  o-y-auto  p-t-10" style="height: 480px;">
      <div class="list-container" style="width:100%;top: 60px;overflow: hidden">
        <div :class="{'item-selected':isSelect(item),'item-normal':!isSelect(item),'m-r-12':index %7!==6}"
             :key="index" @click="itemClick(item,index)" class=" m-b-10 item b-2 bg-white"
             v-for="(item,index) in dataList">
          <div class="w-full h-full">
            <div class="w-full h-120" style="position: relative">
              <div class="w-full h-120 o-hidden flex a-center j-center">
                <img
                  :src="(!item.url)?require('../../assets/common/ic_wutu@2x.png'):item.url + '?x-oss-process=image/resize,w_200,limit_1/format,png'"
                  style="width: 100%;min-height: 120px"/>
              </div>
              <!--鼠标悬停编辑-->
              <div class="flex a-end j-center  w-full h-full  item-editable"
                   style="position: absolute;bottom: 0;left: 0;right: 0;height: 30px;background-color: #0000004d">
                <div @click.stop="" class="w-24 h-24 b-round flex a-center j-center" style="cursor: pointer;">
                  <img class="w-20 h-20" src="../../assets/common/ic-link@2x.png" v-clipboard:copy="item.url"
                       v-clipboard:error="copyOnError" v-clipboard:success="copy"/>
                </div>
                <!--<div @click.stop="itemDelete(item,index)"-->
                <!--class="w-24 h-24 b-round flex a-center j-center m-l-25"-->
                <!--style="cursor: pointer;">-->
                <!--<img class="w-20 h-20" src="../../../assets/common/ic-delete@2x.png"/>-->
                <!--</div>-->
              </div>
              <!--鼠标悬停三角-->
              <div class="triangle" style="position: absolute;top: 0;right: 0;" v-if="isSelect(item)">
              </div>
              <!--鼠标悬停对号-->
              <img class="w-16 h-16" src="../../assets/common/ic-right@2x.png"
                   style="position: absolute;top: 0;right: 0;" v-if="isSelect(item)">
            </div>
            <div class="lin2 m-h-5 m-t-12">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <Page :current="tablePage.currentPage" :page-size="tablePage.pageSize" :total="tablePage.total"
          @on-change="onPageChange" class="m-t-10  w-full" show-total/>
  </div>
</template>

<script>
import ClassChooseWidget from '../common/ClassChooseWidget'
import UpLoadImage from '../common/UpLoadImage'
import {mapActions} from 'vuex'

export default {
  name: 'PicLibWidget',
  components: {UpLoadImage, ClassChooseWidget},
  props: {
    selectObj: {
      type: Object,
      default: () => {
        return {
          maps: new Map(),
          mapLength: 0
        }
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    picurl: {
      type: String,
      default: 'common/desc/',
    },
  },
  data () {
    return {
      objChange: {                               //分类分组帅选
        classId: 0,
        groupId: 0,
        linkurl: ''
      },
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 49,
      },
      // 列表数据
      dataList: [],
      //显示隐藏
      modalShowHide: false,
      //搜索名称
      searchName: '',

      dCGInfo: {
        classId: 0,
        groupId: 0
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.tablePage.currentPage = 1
      this.getPicListData()
      this.getDefaultCGInfo()
    },

    async getDefaultCGInfo () {
      let params = {
        type: 6
      }
      let result = await this.getCategoryLists(params)
      if (result.code === 0) {
        let item = result.data.find(e => {
          return e.isDefault === 1
        })
        if (item && item.id) {
          this.dCGInfo.classId = item.id
          let p = {
            categoryId: item.id,
            type: 6
          }
          let res = await this.getGroupLists(p)
          if (res.code === 0) {
            let itemInfo = res.data.find(e => {
              return e.isDefault === 1
            })
            if (itemInfo && itemInfo.id) {
              this.dCGInfo.groupId = itemInfo.id
            }
          }
        }
      }
    },

    getPicListData () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.searchName) {
        params.title = this.searchName
      }
      if (this.objChange && this.objChange.classId) {
        params.categoryId = this.objChange.classId
      }
      if (this.objChange && this.objChange.groupId) {
        params.groupId = this.objChange.groupId
      }
      this.dataList = []
      this.getPicLists(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.linkurl = child.jumpLink ? child.jumpLink.link || '' : ''
            return child
          })
          this.tablePage.total = res.data.total
        }
      })
    },

    uploadcoversuccess (data) {
      if (data && data.length) {
        let categoryId = this.objChange.classId || 0
        let groupId = this.objChange.groupId || 0
        if (this.objChange.classId < 1 && this.dCGInfo.classId) {
          categoryId = this.dCGInfo.classId || 0
          groupId = this.dCGInfo.groupId || 0
        }
        let params = data.map(res => {
          return {
            title: res.oldname || '',
            url: res.url,
            width: res.width,
            height: res.height,
            groupId: groupId,
            categoryId: categoryId,
            desc: ''
          }
        })
        this.addNewPic(params).then(res => {
          if (res.code === 0) {
            this.tablePage.currentPage = 1
            this.getPicListData()
          }
        })
      }
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    copyOnError (e) {
      this.$Message.info('复制失败')
    },
    itemClick (item, i) {
      let id = item.imgId
      if (this.multiple) {
        if (this.selectObj.maps.has(id)) {
          this.selectObj.maps.delete(id)
        } else {
          this.selectObj.maps.set(id, item)
        }
      } else {
        this.selectObj.maps.clear()
        this.selectObj.mapLength = 0
        this.selectObj.maps.set(id, item)
      }
      this.selectObj.mapLength = this.selectObj.maps.size
    },
    isSelect (item) {
      let id = item.imgId
      if (this.selectObj.mapLength && this.selectObj.maps.has(id)) {
        return true
      } else {
        return false
      }
    },
    /**
     * 输入搜索筛选
     */
    onSearchClick () {
      this.tablePage.currentPage = 1
      this.getPicListData()
    },

    /**
     * 分类分组筛选
     * @param e
     */
    onClassGroupChange (e) {
      this.objChange = e
      this.tablePage.currentPage = 1
      this.getPicListData()
    },
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.getPicListData()
    },

    ...mapActions([
      'getPicLists',
      'delPic',
      'addNewPic',
      'getCategoryLists',
      'getGroupLists'
    ])
  }
}
</script>


<style lang="scss" scoped>

  .list-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    overflow-x: hidden;
  }

  .item {
    width: 140px;
    height: 170px;
    flex-direction: row;
    margin-bottom: 10px;
  }

  .item-selected {
    //border-color: #0EA4FB;
    //border-width: 2px;
    border: 2px solid #0EA4FB;
  }

  .item-normal {
    //border-color: #0EA4FB;
    //border-width: 2px;
    border: 2px solid white;
  }

  .item-editable {
    display: none;
  }

  .item:hover .item-editable {
    display: flex;
  }

  .lin2 {
    color: #333;
    max-width: 600px;
    font-size: 13px;
    line-height: 20px;
    //height: 40px;
    //margin-top: 6px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
    -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
    -webkit-line-clamp: 1; /** 显示的行数 **/
    overflow: hidden; /** 隐藏超出的内容 **/
  }


  .triangle {
    width: 0;
    height: 0;
    border-color: transparent #0F8CFB;
    border-width: 0 25px 25px 0;
    border-style: solid;
  }

  .modal-product-link ::v-deep {
    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }

  //扩大商品链接按钮点击范围
  .icon-link {
    padding: 7px;
    margin: 0;
  }

  //扩大商品链接按钮点击范围
  #input-product ::v-deep {
    .ivu-input-group-append {
      padding: 0;
    }
  }
</style>
